
import {forkJoin as observableForkJoin, Observable} from 'rxjs';
import {DashboardService} from '../../shared/services';
import {Inject} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';

export class DashboardResolver implements Resolve<any[]> {

  constructor( @Inject(DashboardService) private service: DashboardService) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any[]> {
    return observableForkJoin(this.service.recent(), this.service.statistics(),
      this.service.today(), this.service.timeline());
  }
}
